export const lang = {
  locale: '日本語',
  toolbar: {
    Login: 'ログイン',
    Logout: 'ログアウト',
    Home: 'ホーム',
    Profile: 'プロファイル',
    Register: 'アカウントを作成',
    Recovery: 'パスワード再発行',
    PasswordChange: 'パスワード変更',
    UserCenter: '個人センター',
    Cancel: 'キャンセル',
    OK: 'OK',
    Submit: '送信',
    Save: '一時保存',
    Confirm: '確認',
    Columns: '表示列',
    AddMeta: 'メータデータを追加',
    AddParagraph: '段落を追加',
    AddPart: 'パーツを追加',
    Add: '新規',
    Delete: '削除',
    Edit: '編集',
    Modify: '修正',
    Preview: 'プレビュー',
    Details: '詳細',
    Search: '検索',
    Select: '選択',
    Reset: 'リセット',
    About: 'About',
    Console: 'コンソール',
    TryIT: 'すぐ体験する',
    Chat: 'チャット',
    Release: 'リリース',
    Restore: '復元'
  },
  words: {
    newpassword: '新しいパスワード',
    password: 'パスワード',
    password2: 'パスワード再入力',
    accountconfirm: 'アカウントの確認',
    accountconfirmpoint: 'メールアドレスを入力し、確認ボタンでアカウント存在するかを確認',
    otherlogin: 'その他ログイン',
    member: '会員リスト',
    stamp: 'スタンプ利用状況',
    coupon: 'クーポン利用状況',
    stampcode: 'スタッフコード発行',
    coupondef: 'クーポン管理',
    nexttitle: 'SCWS マネジメントコンソール',
    nextsubtitle: '次世代 SemcentCloud ウェブサービスマネジメントコンソール',
    nextdescription: "<ul class='list-unstyled'><li>言語国際化</li><li>操作プロセスより簡素化</li><li></li><li>ユーザーが操作より明確に</li><li>機能：<ul><li>会員管理</li><li>クーポン管理</li><li>スタッフ管理</li></ul></li><li>SemcentCloud提供するウェブサービスを一元管理する管理システムです。</li></ul>",
    cms: 'コンテンツ管理システム',
    lms: '学習管理システム',
    ec: 'ショッピング管理システム',
    crm: '会員、スタンプ、クーポン、予約などを管理する。'
  },
  dict: {
    total: '総額',
    subtotal: 'サブ金額',
    addr: '住所',
    init: '初期値',
    inc: '増加',
    amount: '金額',
    way: '方式',
    pfromto: '価格範囲',
    qfromto: '数量範囲',
    initdate: '初期日付',
    initstock: '初期在庫数',
    stockavailable: '在庫数',
    itemcd: '品番',
    titleshort: '略称',
    colornm: '色',
    sizenm: 'サイズ',
    unit: '単位',
    iprice: '入庫価格',
    oprice: '販売価格',
    dprice: '表示価格',
    spec: 'スペーク',
    taxtype: '税区分',
    taxrate: '税率',
    axb: 'axb',
    woc: 'woc',
    province: '県',
    city: '市',
    contactaddr: '住所',
    contactmobile: '電話',
    contactname: '連絡者',
    dashboard: "ダッシュボード",
    paragraph: "段落",
    additional: "付帯入力",
    showGallery: "画像表示",
    result: "結果",
    autoJudge: "自動判定",
    username: "ユーザーID",
    password: "パスワード",
    contact: "連絡先",
    history: "履歴",
    name: "お名前",
    order: "項番",
    options: "選択肢",
    questiontype: "質問タイプ",
    answer: "答え",
    subject: "科目",
    quantity: "数量",
    email: "メールアドレス",
    telephone: "電話番号",
    mobile: "携帯番号",
    account: "アカウント",
    estimate: "予定",
    actual: "実績",
    fee: "金額",
    score: "採点",
    judge: "判定",
    correct: "正解",
    totalScore: "総得点",
    passScore: "合格ライン",
    updator: "更新者",
    date: "日付",
    reservedate: "予約時間",
    createdate: "作成日付",
    updatedate: "更新日付",
    datetrans: "取引日",
    timecycle: "サイクル",
    timestart: "開始時間",
    timeend: "終了時間",
    timestep: "間隔",
    timesteplimit: "上限",
    datestart: "開始日",
    dateend: "終了日",
    datefinish: "完了日",
    dateissued: "発行日",
    dateused: "使用日",
    expire: "期限",
    status: "状態",
    sex: "性別",
    cardid: "カード番号",
    title: "タイトル",
    id: "ID",
    generate: "生成",
    template: "テンプレート",
    block: "ブロック",
    codetype: "コード種別",
    parameter: "パラメータ",
    return: "戻り値",
    datatype: "データ型",
    condition: "条件",
    from: "開始",
    to: "終了",
    subscript: "添え字",
    details: "詳細",
    stampid: "スタンプ番号",
    gallary: "画像",
    text: "テキスト",
    subtitle: "サブタイトル",
    body: "本文",
    summary: "まとめ",
    tags: "タグ",
    preface: "前書き",
    category: "カテゴリ",
    dictionary: "辞書",
    memo: "メモ",
    code: "コード",
    value: "値",
    cname: "名称(中)",
    jname: "名称(日)",
    ename: "名称(英)",
    kbn: "区分",
    ord: "表示順",
    pid: "親ID",
    lv: "階層",
    target: "対象",
    type: "種別",
    supervisor: "責任者",
    router: "ルート",
    invite: "ユーザ要請",
    cost: "工数",
    costest: "予定工数",
    costact: "実績工数",
    comment: "コメント",
    staff: "担当者",
    staffto: "割り当て",
    priority: "優先度",
    notetag: "付箋",
    flowtype: "申請区分",
    career: "業界",
    project: "プロジェクト",
    auth_group: "権限",
    auth_list: "リスト",
    auth_view: "表示",
    auth_add: "追加",
    auth_edit: "修正",
    auth_del: "削除",
    auth_preview: "プレビュー",
    auth_details: "詳細",
    auth_import: "インポート",
    auth_export: "エクスポート",
    auth_setup: "設定"
  },
  datatable: {
    info: '総 _PAGES_ 頁 ／ _PAGE_ 頁目、 総件数： _MAX_ ',
    infoEmpty: 'データがありません'
  },
  msg: {
    toRecovery: 'ログインできない場合',
    toLogin: 'すでにアカウントをお持ちですか？',
    toRegister: 'アカウントを取得する場合',
    toLogout: 'ログアウトしますか?',
    toPreview: 'プレビュー用ページを生成しますが、継続しますか？?',
    toDelete: '削除しますか?',
    toContinue: '継続しますか?',
    toOtherLogin: 'cloud.semcent.comのアカウントをお持ちですか?',
    toRestore: '一時保存データから読み込めますか？'
  },
  error: {
    serverError: 'サーバーが応答しません。管理者にご連絡ください。{error}',
    serverNormal: 'サーバー正常稼働中',
    notLtnM: 'サイズは{n}M以下にしてください!',
    notAllowedFmt: '画像ファイルを選択してください！',
    invalid: '{str}が不正です！',
    required: '{str}を入力してください！',
    notExistAccount: 'アカウントが存在しません！',
    notAllowed: '{str}のため、変更または削除できません！',
    failed: '{str}に失敗しました！',
    failedLogin: 'パスワードが一致していません。<br>再度試してください！',
    failedRequest: 'リクエスト失敗： {err}'
  },
  info: {
    succeedRegister: 'アカウントを作成されました。\nログイン画面に遷移します！',
    succeedRegisterDup: 'アカウントは既に作成されています。\nログイン画面に遷移します！',
    succeedToLogin: '正常にログインしました！',
    succeedRequst: 'リクエストが正しく実行されました。',
    succeedInsert: '正常に追加しました。',
    succeedUpdate: '正常に更新しました。',
    succeedDelete: '正常に削除しました。',
    succeedSave: '正常に保存にしました。'
  },
  notice: {
    updatePost: '[{createdate}] {id}: <span class="text-info">{title}</span>は更新されました。',
    createReserve: '[{createdate}] <span class="text-info">{custname}</span> 様から予約が入ってきました。',
    updateReserve: '[{createdate}] 予約番号: <span class="text-info">{id}</span>は<mark>{status}</mark>に変更しました。',
    addStamp: '[{createdate}] <span class="text-primary">カード番号: {cardid}</span>はスキャンでスタンプを受け取りました。',
    addStampByCode: '[{createdate}] <span class="text-primary">カード番号: {cardid}</span>は番号入力でスタンプを受け取りました。番号:{stampcode}'
  },
  title: {
    style: "スタイル",
    activity: "アクティビティ",
    menu: 'メニュー',
    ec: '販売管理',
    depot: '倉庫',
    supplier: '仕入先',
    item: '品番',
    stock: '在庫',
    discount: '値引',
    freight: '運賃',
    order: '受注',
    member: '会員',
    coupon: 'クーポン',
    mntcoupon: 'クーポンメンテナンス',
    stamp: 'スタンプ',
    stampcode: 'スタンプコード',
    content: '内容管理',
    bucket: 'バケット',
    post: '投稿',
    groupware: 'グループウェア',
    report: '回覧・レポート',
    message: 'メッセージ',
    notice: 'お知らせ',
    todo: 'TODO',
    note: 'メモ',
    record: '議事録',
    flow: '休暇届',
    resource: '設備・施設',
    reserve: '予約',
    schedule: '日程',
    calendar: 'カレンダー',
    crm: '顧客管理',
    lms: '学習管理システム',
    test: '試験',
    template: 'テンプレート',
    construct: '設計',
    question: '問題集',
    examresult: '試験結果',
    customer: '取引先',
    contact: '連絡先',
    case: '商談',
    faq: 'FAQシステム',
    faqreply: '応答',
    consult: '問い合わせ',
    document: 'ドキュメント',
    product: '製品',
    solution: 'ソリューション',
    setting: '設定',
    information: '基本情報',
    role: '役割',
    roletarget: '役割対象関連',
    roleperm: '役割権限関連',
    perm: '権限',
    org: '組織',
    pos: '職務',
    grp: 'グループ',
    user: 'ユーザ',
    grant: '権限確認',
    exam: "試験"
  },
  faq: {
    msgWelcome: '{0}はFaqシステムに入りました。'
  },
  chat: {
    start: '開始',
    send: '発送',
    sendpromote: 'メッセージを入力してください',
    sayto: '私は{0}に答えた',
    say: '{0}は話した'
  },
  src: {
    root: '/*\nPGM ID:{id}\nPGM name{title}*/\n{body}',
    method: 'function {id} () \n{body}\n',
    for: 'for (var {idx} = {start}; {idx} < {max}){body}\n'
  }
}
